// extracted by mini-css-extract-plugin
export var text = "_78-0";